/* eslint-disable*/
import VueStoreService from './VueStoreService';
const VoucherService = {
    async getVouchers(url,store){
        var resp = await VueStoreService.get("voucher"+url, store)
        return resp;
    },
    async saveVoucher(data,store){
        var resp = await VueStoreService.post("voucher",data,store)
        return resp;
    },
    async getVoucherById(establishment_id,store){
        var resp = await VueStoreService.get("voucher/"+establishment_id,store)
        return resp;
    },

    async updateVoucher(voucher_id,data,store){
        var resp = await VueStoreService.patch("voucher/"+voucher_id,data,store)
        return resp;
    },

    async deleteVoucher(voucher_id,store){
        var resp = await VueStoreService.delete("voucher/"+voucher_id,store)
        return resp;
    },
}

export default VoucherService;